import type { SagaIterator } from 'redux-saga';
import { all, call, delay, put, takeLatest } from 'redux-saga/effects';
import { DISMISS_MESSAGE, SHOW_MESSAGE } from './action-types';
import { type MessageAction, showMessage } from './actions';
import type { MessageType } from './types';

function* validateOnPause(action: MessageAction): SagaIterator {
  if (action.meta?.timeout) {
    yield delay(action.meta.timeout);
    yield put({ type: DISMISS_MESSAGE });
  }
}

export function* showErrorMessageSaga<Action extends { payload: string }>({ payload }: Action): SagaIterator {
  yield put(showMessage('error', payload, 5000));
}

export function showMessageSaga<T>(level: MessageType, getMessage: ((action: T) => string) | string, timeout?: number) {
  return function* (action: T): SagaIterator {
    if (typeof getMessage === 'string') {
      yield put(showMessage(level, getMessage, timeout));
    } else if (getMessage instanceof Function) {
      const message = yield call(getMessage, action);
      yield put(showMessage(level, message, timeout));
    }
  };
}

export default function* root(): SagaIterator {
  yield all([takeLatest(SHOW_MESSAGE, validateOnPause)]);
}
